{
  "colorSwatchPicker": "Uzorci boja",
  "dropzoneLabel": "Zona spuštanja",
  "selectPlaceholder": "Odaberite stavku",
  "tableResizer": "Promjena veličine"
}
